export default [
  {
    name: "Basilisk V3",
    brand: "razer",
    price: 69.99,
    imageSrc: "razer-basilisk",
    description: `The quintessential ergonomic gaming mouse for customized performance.`,
  },
  {
    name: "Tartarus Pro",
    brand: "razer",
    price: 129.99,
    imageSrc: "razer-tartarus",
    description:
      "32-key gaming keypad with RGB lights and programmable keys and macros.",
  },
  {
    name: "BlackWidow V3",
    brand: "razer",
    price: 139.99,
    imageSrc: "razer-black-widow",
    description:
      "Mechanical wireless gaming keyboard with green mechanical switches.",
  },
  {
    name: "Audio Mixer",
    brand: "razer",
    price: 249.99,
    imageSrc: "razer-audio-mixer",
    description:
      "All in one streaming/broadcasting mixer - 4 channel design - XLR Preamp.",
  },
  {
    name: "Kraken Ultimate",
    brand: "razer",
    price: 129.99,
    imageSrc: "razer-kraken-ultimate",
    description: "THX 7.1 Spatial Surround Sound - Chroma RGB Lighting",
  },
  {
    name: "Hammerhead",
    brand: "razer",
    price: 129.99,
    imageSrc: "razer-hammerhead",
    description:
      "Wireless Bluetooth gaming earbuds - Chroma RGB Lighting - 60ms response time.",
  },
  {
    name: "G502 HERO",
    brand: "logitech",
    price: 79.99,
    imageSrc: "logitech-g502",
    description:
      "High performance wired gaming mouse, 25K DPI, 11 programmable buttons.",
  },
  {
    name: "HyperX Cloud II",
    brand: "hyperX",
    price: 99.99,
    imageSrc: "hyperx-cloud",
    description:
      "7.1 Surround sound wired headset for PC, PS5, PS4, Xbox Series X|S, Xbox One.",
  },
  {
    name: "Logitech F310",
    brand: "logitech",
    price: 24.99,
    imageSrc: "logitech-f310",
    description:
      "Blue wired gamepad controller console like layout, 4 Switch D-Pad",
  },
];
